import {motion} from 'framer-motion';
import {
  DropdownTag,
  DropdownTagProps,
  Flag,
  FlagProps,
  Tooltip,
  TooltipProps,
} from 'platform/components';

import {TestIdProps, suffixTestId} from 'shared/web';

import {SkeletonLoadingBox} from './SkeletonLoadingBox';

interface EntityHeaderFlag extends Omit<FlagProps, 'size'> {
  tooltip?: TooltipProps;
}

interface EntityHeaderDropdownFlag extends Omit<DropdownTagProps, 'size'> {
  tooltip?: TooltipProps;
}

export interface SkeletonLoadingListProps extends TestIdProps {
  flags: EntityHeaderFlag[] | undefined;
  dropdownFlags: EntityHeaderDropdownFlag[] | undefined;
  isLoading?: boolean;
}

export const EntityHeaderFlags = (props: SkeletonLoadingListProps) => (
  <>
    {props.flags?.map((flag: EntityHeaderFlag, index) => (
      <motion.div key={`${flag.label}-${flag.colorScheme}-${index}`} layout="position">
        <SkeletonLoadingBox isLoading={props.isLoading} width={22} height={6} borderRadius="small">
          <Tooltip
            {...flag.tooltip}
            data-testid={suffixTestId(`entityHeader-flags-tooltip-[${index}]`, props)}
          >
            <Flag
              {...flag}
              data-testid={suffixTestId(`entityHeader-flags-flag-[${index}]`, props)}
            />
          </Tooltip>
        </SkeletonLoadingBox>
      </motion.div>
    ))}
    {props.dropdownFlags?.map((flag, index) => (
      <motion.div key={`${flag.label}-${flag.colorScheme}-${index}`} layout="position">
        <SkeletonLoadingBox isLoading={props.isLoading} width={22} height={6} borderRadius="small">
          <Tooltip
            {...flag.tooltip}
            data-testid={suffixTestId(`entityHeader-dropdownFlags-tooltip-[${index}]`, props)}
          >
            <DropdownTag
              {...flag}
              size="default"
              data-testid={suffixTestId(`entityHeader-dropdownFlags-flag-[${index}]`, props)}
            />
          </Tooltip>
        </SkeletonLoadingBox>
      </motion.div>
    ))}
  </>
);
